import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RoleProvider, useRole } from './RoleContext'; // Adjust the path accordingly
import ScrollToTop from "./components/scrolltop/ScrollTop";
import ConnectGoogle from "./pages/connectgoogle/ConnectGoogle";
import ChangePassword from "./pages/changepassword/ChangePassword";
import ForgotPassword from "./pages/forgotpassword/ForgotPassword";
import Layout from "./pages/layout/Layout";
import ResetPassword from "./pages/resetpassword/ResetPassword";
import Dashboard from "./pages/dashboard/Dashboard";
import BusinessSettings from "./pages/businesssettings/BusinessSettings";
import SendInvites from "./pages/send-invites/SendInvites";
import MultipleInvites from "./pages/send-invites/multipleinvites/MultipleInvites";
import InviteSettings from "./pages/invite-settings/InviteSettings";
import Recepients from "./pages/recepients/Recepients";
import Reviews from "./pages/reviews/Reviews";
import ManageAccountChannels from "./pages/accountchannels/manageacccountchannels/ManageAccountChannels";
import CreateAccountChannel from "./pages/accountchannels/createaccountchannel/CreateAccountChannel";
import EditAccountChannel from "./pages/accountchannels/editaccountchannel/EditAccountChannel";
import Reporting from "./pages/reporting/Reporting";
import Settings from "./pages/settings/Settings";
import Support from "./pages/support/Support";
import Login from "./pages/login/Login";
import ChangeMembership from "./pages/changeMembership/changeMembership";



function App() {
  const role = useRole()

  return (
    <RoleProvider>
      <BrowserRouter basename="/grow">
        <ScrollToTop />
        <Routes>
          {/* App */}
          <Route path='/' element={<Login />} />
          <Route path='/connect-google' element={<ConnectGoogle />} />
          <Route path='/change-password' element={<ChangePassword />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route path='/' element={<Layout />}>
            <Route path='reset-password' element={<ResetPassword />} />
              <Route path='dashboard' element={<Dashboard />} />
              <Route path='change-membership' element={<ChangeMembership />} />
              <Route path='business-settings' element={<BusinessSettings />} />
              <Route path='single-invite' element={<SendInvites />} />
              <Route path='multiple-invites' element={<MultipleInvites />} />
              <Route path='invite-settings' element={<InviteSettings />} />
              <Route path='recipients' element={<Recepients />} />
              <Route path='reviews' element={<Reviews />} />
              <Route path='manage-account-channels' element={<ManageAccountChannels />} />
              <Route path='create-account-channel' element={<CreateAccountChannel />} />
              <Route path='edit-account-channel/:account_channel_id' element={<EditAccountChannel />} />
              <Route path='reporting' element={<Reporting />} />
              <Route path='account-settings' element={<Settings />} />
              <Route path='support' element={<Support />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </RoleProvider>
  );
}

export default App;